export const vehicleModelsResource = {
  name: 'Vehicle Models',
  fields: {
    id: 'ID',
    name: 'Model',
    normalizedName: 'Normalized Name',
    brand: 'Brand',
    brandName: 'Brand',
    translationEn: 'Name (English)',
    translationZhTw: 'Name (繁體中文)',
    translationZhCn: 'Name (简体中文)',
    createdAt: 'Created',
    updatedAt: 'Updated',
  },
  sections: {
    details: 'Model Details',
  },
  help: {
    brandImmutable: 'Brand cannot be changed after creation.',
  },
  actions: {
    importPdf: 'Import from PDF',
    importCsv: 'Import from CSV',
  },
  create: {
    title: 'Create Vehicle Model',
  },
  edit: {
    title: 'Edit Vehicle Model',
  },
  notifications: {
    created: 'Vehicle model created',
    updated: 'Vehicle model updated',
  },
  errors: {
    duplicate: 'A model with this name already exists for this brand',
    brandNotFound: 'Brand not found',
  },
  import: {
    title: 'Import models from CSV',
    uploadHint: 'Choose a CSV file (max 10MB) with columns "brand_name" and "model_name".',
    uploadHintLine2: 'Tip: run the parse-epd-ev-pdf skill to convert the EPD HK PDF into this format.',
    selectFile: 'Select file',
    parsing: 'Parsing file and checking against existing catalog...',
    summary: '%{total} rows: %{fresh} new, %{existing} already exist (will be skipped).',
    willInsert: 'Will be inserted (%{count})',
    willSkip: 'Already in catalog — will be skipped (%{count})',
    addOnlyNote: 'Existing brands and models are never deleted — only new entries are added.',
    submit: 'Import %{count} new',
    submitting: 'Submitting...',
    completeMsg: 'Import complete.',
    rowsReceived: 'Rows received',
    brandsCreated: 'Brands created',
    modelsInserted: 'Models inserted',
    modelsSkipped: 'Models skipped (already existed)',
    success: 'Models imported',
    errors: {
      notSupported: 'Please select a CSV file',
      tooLarge: 'File too large (max 10MB)',
      parseFailed: 'Failed to parse file',
    },
  },
};

export const vehicleModels = {
  'vehicle-models': vehicleModelsResource,
};
